import { Constructor } from './constructor.type';
import { DynamicProperty } from '../decorators/dynamic-property.decorator';

export interface IDynamicLabelMixin {
  label: string | undefined;
}
export type DynamicLabelCtor = Constructor<IDynamicLabelMixin>;

export function mixinDynamicLabel<T extends Constructor<{}>>(base: T): DynamicLabelCtor & T {
  class DynamicLabelMixin extends base implements IDynamicLabelMixin {
    @DynamicProperty() label: string | undefined;

    constructor(...args: any[]) {
      super(...args);
    }
  }

  return DynamicLabelMixin;
}
